import { isError, useMutation, useQuery, useQueryClient } from "react-query";
import {
  GetAllActivePersonByTenantId,
  GetAllActivePersonsByTenantId,
  GetAllHorizontalAlignmentByTenantId,
  GetAllOKRStateByTenantId,
  GetAllScoreLevelsByTenantId,
  AddKeyResult,
  getStrategyMapTenantId,
  getAllObjectiveByPeriodId,
  getAllObjectiveByPeriodId1,
  getAllObjectiveByPeriodId2,
  GetPersonAndTeamCountByTenantId,
  AddObjective,
  getObjectiveDetailsById,
  EditObjective,
  getAllObjectiveDefinitionLevelByTenantId,
  getAllObjectiveDefinitionLevelByTenantId1,
  GetAllObjectiveOKRStateByTenantId,
  getObjectiveDetails,
  getKeyResultDetailsById,
  getAllObjectiveByPersonId,
  editKeyResult,
  GetObjectiveAndKeyResultCountByPeriodId,
  deleteKr,
  getAllObjectiveNameWithKeyResultsByTenantId,
  getAllTeamAndPersonNameByTenantId,
  deleteObjective,
  getAllVerticalAlignmentByTenantId,
  getFilterByTenantId,
} from "../Api/index";
import { QueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { objectiveFilterType } from "../../../types";
import { getMyKeyResultByTenantId } from "../../TenantDash/Api";

type option = {
  id: string;
  name: string;
};

const useDeleteObject = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (userData: any) => deleteObjective(userData),
    onSuccess: (data: any) => {
      queryClient.invalidateQueries("GetAllObjectiveByPeriodId");
      queryClient.invalidateQueries("GetObjectiveAndKeyResultCountByPeriodId");
    },
  });
};

// tenantId:any
const useGetAllActivePersonByTenantId = (tenantId: string | null) => {
  return useQuery(
    ["GetAllActivePersonByTenantId", tenantId],
    GetAllActivePersonByTenantId,
    {
      enabled: !!tenantId,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        //    console.log(data)
      },
      onError: (err: any) => {
        //    console.log(err)
      },
      select: (data: any) => {
        let rawData = data?.data?.data;
        let tranFormed;
        if (rawData) {
          tranFormed = rawData.map(({ name, id }: option) => {
            return { key: name, value: id };
          });
        }

        return tranFormed;
      },
    }
  );
};

const useGetAllActivePersonByTenantIdW = (tenantId: string | null) => {
  return useQuery(
    ["GetAllActivePersonsByTenantId", tenantId],
    GetAllActivePersonsByTenantId,
    {
      enabled: !!tenantId,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        //    console.log(data)
      },
      onError: (err: any) => {
        //    console.log(err)
      },
      select: (data: any) => {
        return data?.data?.data;
      },
    }
  );
};

const useGetAllHorizontalAlignmentByTenantId = (
  horzIds: any,
  definitionId: string
) => {
  return useQuery(
    ["GetAllHorizontalAlignmentByTenantId", horzIds, definitionId],
    GetAllHorizontalAlignmentByTenantId,
    {
      enabled: !!horzIds.definitionId,
      //cacheTime: Infinity,
      //refetchOnWindowFocus: false,
      onSuccess: (data) => {
        // console.log(data)
      },
      onError: (err) => {
        // console.log(err)
      },
      select: (data: any) => {
        let rawData = data?.data?.data;
        // console.log(rawData)
        // let transFormed = rawData?.map((item: any) => {
        //   let { name, id } = item;
        //   return { year: id, title: name };
        // });
        // year, title
        return rawData;
      },
    }
  );
};

const useGetAllOKRStateByTenantId = (tenantId: string | null) => {
  return useQuery(
    ["GetAllOKRStateByTenantId", tenantId],
    GetAllOKRStateByTenantId,
    {
      enabled: !!tenantId,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onSuccess: (data: any) => {
        //   console.log(data)
      },
      onError: (err: any) => {
        //  console.log(err)
      },
      select: (data) => {
        let rawData = data?.data?.data;
        let tranformed = rawData
          .filter((item: any) => item.name !== "بسته شده")
          .map(({ id, name }: any) => {
            return { label: name, id: id };
          });
        return tranformed;
      },
    }
  );
};
const useGetAllScoreLevelsByTenantId = (tenantId: string | null) => {
  return useQuery(
    ["GetAllScoreLevelsByTenantId", tenantId],
    GetAllScoreLevelsByTenantId,
    {
      enabled: !!tenantId,
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      onSuccess: (data: any) => {
        // console.log(data)
      },
      onError: (err: any) => {
        //  console.log(err)
      },
      select: (data: any) => {
        let rawData = data?.data?.data;
        // console.log(rawData);
        let levelids = rawData.map(({ id, name }: any) => {
          return { scoreLevelId: id, value: "", name };
        });
        return levelids;
        // console.log(levelids)
      },
    }
  );
};

const useAddKeyResult = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => AddKeyResult(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("getObjectiveDetails");
      queryClient.invalidateQueries("GetObjectiveAndKeyResultCountByPeriodId");
      //   console.log(data)
    },
  });
};


const useGetMyKeyResultsByTenantId=(periodId:string | null,profileTenantId:string | null,personId:string | null)=>{
  // console.log(periodId)
return useQuery(['GetMyKeyResultByTenantId',periodId,profileTenantId,personId],getMyKeyResultByTenantId,{
  enabled:!!periodId,
  // cacheTime:Infinity,
  refetchOnWindowFocus:false,
  onSuccess:(data:any)=>{
  // console.log(data)
  }
  ,onError:(err)=>{
  // console.log(err)
  } ,
  select:(data)=>{
  let rawData=data?.data?.data;
  return rawData
  }
})
}

const useEditKeyResult = (localEditKrSuccess: any) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => editKeyResult(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("getObjectiveDetails");
      // queryClient.invalidateQueries("getMyKeyResultByTenantId");
      localEditKrSuccess();
      //   console.log(data)
    },
  });
};

const useGetAllObjectiveByPeriodId = (
  periodId: string | null,
  profileTenantId: string | null,
  onSuccesss: (data: any) => void
) => {
  // console.log(periodId)
  return useQuery(
    ["GetAllObjectiveByPeriodId", periodId, profileTenantId],
    getAllObjectiveByPeriodId,
    {
      enabled: !!periodId,
      // cacheTime:Infinity,
      refetchOnWindowFocus: false,
      onSuccess: (data: any) => {
        onSuccesss(data);
      },
      onError: (err) => {
        // console.log(err)
      },
      select: (data) => {
        let rawData = data?.data?.data;
        return rawData;
      },
    }
  );
};

const useGetStrategyMapTenantId = (
  periodId: string | null,
  profileTenantId: string | null,
  onSuccesss: (data: any) => void
) => {
  // console.log(periodId)
  return useQuery(
    ["GetStrategyMapTenantId", periodId, profileTenantId],
    getStrategyMapTenantId,
    {
      enabled: !!profileTenantId,
      // cacheTime:Infinity,
      refetchOnWindowFocus: false,
      onSuccess: (data: any) => {
        onSuccesss(data);
      },
      onError: (err) => {
        // console.log(err)
      },
      select: (data) => {
        let rawData = data?.data?.data;
        return rawData;
      },
    }
  );
};

const useGetAllObjectiveByPeriodId1 = (
    periodId: string | null,
    profileTenantId: string | null,
    onSuccesss: (data: any) => void
  ) => {
    // console.log(periodId)
    return useQuery(
      ["GetAllObjectiveByPeriodId1", periodId, profileTenantId],
      getAllObjectiveByPeriodId1,
      {
        enabled: !!periodId,
        // cacheTime:Infinity,
        refetchOnWindowFocus: false,
        onSuccess: (data: any) => {
          onSuccesss(data);
        },
        onError: (err) => {
          // console.log(err)
        },
        select: (data) => {
          let rawData = data?.data?.data;
          return rawData;
        },
      }
    );
  };


  const useGetAllObjectiveByPeriodId2 = (
    profileTenantId: string | null,
    onSuccesss: (data: any) => void
  ) => {
    // console.log(periodId)
    return useQuery(
      ["GetAllObjectiveByPeriodId2", profileTenantId],
      getAllObjectiveByPeriodId2,
      {
        // enabled: !!periodId,
        // cacheTime:Infinity,
        refetchOnWindowFocus: false,
        onSuccess: (data: any) => {
          onSuccesss(data);
        },
        onError: (err) => {
          // console.log(err)
        },
        select: (data) => {
          let rawData = data?.data?.data;
          return rawData;
        },
      }
    );
  };

  const useGetPersonAndTeamCountByTenantId = (
    profileTenantId: string | null
  ) => {
    // console.log(periodId)
    return useQuery(
      ["GetPersonAndTeamCountByTenantId", profileTenantId],
      GetPersonAndTeamCountByTenantId,
      {
        // enabled: !!periodId,
        // cacheTime:Infinity,
        refetchOnWindowFocus: false,
        onSuccess: (data: any) => {
          let rawData = data?.data?.data;
          return rawData;
        },
        onError: (err) => {
          // console.log(err)
        },
        select: (data) => {
          let rawData = data?.data?.data;
          return rawData;
        },
      }
    );
  };

  const useGetObjectiveAndKeyResultCountByPeriodId = (
    periodId: string | null,
    profileTenantId: string | null
  ) => {
    // console.log(periodId)
    return useQuery(
      ["GetObjectiveAndKeyResultCountByPeriodId", periodId, profileTenantId],
      GetObjectiveAndKeyResultCountByPeriodId,
      {
        enabled: !!periodId,
        // cacheTime:Infinity,
        refetchOnWindowFocus: false,
        onSuccess: (data: any) => {
          let rawData = data?.data?.data;
          return rawData;
        },
        onError: (err) => {
          // console.log(err)
        },
        select: (data) => {
          let rawData = data?.data?.data;
          return rawData;
        },
      }
    );
  };

const useGetAllObjectiveByPersonId = (
  periodId: string | null,
  profileTenantId: string | null,
  onSuccesss: (data: any) => void
) => {
  // console.log(periodId)
  return useQuery(
    ["GetAllObjectiveByPersonId", periodId, profileTenantId],
    getAllObjectiveByPersonId,
    {
      enabled: !!periodId,
      // cacheTime:Infinity,
      refetchOnWindowFocus: false,
      onSuccess: (data: any) => {
        onSuccesss(data);
      },
      onError: (err) => {
        // console.log(err)
      },
      select: (data) => {
        let rawData = data?.data?.data;
        return rawData;
      },
    }
  );
};

//Amir
const useGetFilterByTenantId = (
  tenantId: string,
  periodId: string | null,
  onSuccesss: (data: any) => void
) => {
  // console.log(periodId)
  return useQuery(
    ["GetFilterByTenantId", tenantId, periodId],
    getFilterByTenantId,
    {
      enabled: !!periodId,
      // cacheTime:Infinity,
      refetchOnWindowFocus: false,
      onSuccess: (data: any) => {
        onSuccesss(data);
        // console.log(data);
      },
      onError: (err) => {
        // console.log(err)
      },
      select: (data) => {
        let localData = data?.data?.data;
        // let localData = { ...data };
        localData = {
          ...localData,
          stateDtosChecked: false,
          teamDtosChecked: false,
          personDtosChecked: false,
        };
        localData.personDtos = localData.personDtos.map(
          (item: objectiveFilterType) => ({
            ...item,
            checked: false,
          })
        );
        localData.stateDtos = localData.stateDtos.map(
          (item: objectiveFilterType) => ({
            ...item,
            checked: false,
          })
        );
        localData.teamDtos = localData.teamDtos.map(
          (item: objectiveFilterType) => ({
            ...item,
            checked: false,
          })
        );
        return localData;
      },
    }
  );
};

// AddObjective
//  const useAddObjective=(onSuccesss:any)=>{
// const queryClient=useQueryClient()

//       return useMutation({
//     mutationFn: (data:any) => addObjective(data),
//     onSuccess: (data) => {
//         onSuccesss()
//         queryClient.invalidateQueries('GetAllObjectiveByPeriodId')
//     //   console.log(data)
//     },
//   });
//  }

const useAddObjective = (onError: any, onSuccess: any) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) => AddObjective(data),
    onSuccess: (data) => {
      if (data && data.data && data.data.isSuccess) {
        queryClient.invalidateQueries("GetAllObjectiveByPeriodId");
        queryClient.invalidateQueries("GetObjectiveAndKeyResultCountByPeriodId");
        onSuccess();
      } else throw new Error(data.data.metaData.message);
    },
    onError: (err) => {
      onError(err);
    },
  });
};

const useEditObjective = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) => EditObjective(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("GetAllObjectiveByPeriodId");
      queryClient.invalidateQueries("GetMyObjectiveByTenantId");
    },
    onError: (err) => {
      console.log(err);
    },
  });
};

const useGetAllObjectiveDefinitionLevelByTenantId = (
  tenantId: string | null
) => {
  return useQuery(
    ["getAllObjectiveDefinitionLevelByTenantId", tenantId],
    getAllObjectiveDefinitionLevelByTenantId,
    {
      enabled: !!tenantId,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onError: (err: any) => {},
      select: (data: any) => {
        let rawData = data?.data?.data;
        //  console.log(rawData)
        let transformed = rawData.map((item: any) => {
          let { name: key, id: value, isCompany } = item;
          return { key, value, isCompany };
        });
        return transformed;
      },
    }
  );
};

const useGetAllObjectiveDefinitionLevelByTenantId1 = (
  tenantId: string | null,
  definitionId: string
) => {
  return useQuery(
    ["getAllObjectiveDefinitionLevelByTenantId1", tenantId, definitionId],
    getAllObjectiveDefinitionLevelByTenantId1,
    {
      enabled: !!tenantId,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onError: (err: any) => {},
      select: (data: any) => {
        let rawData = data?.data?.data;
        //  console.log(rawData)
        let transformed = rawData.map((item: any) => {
          let { name: key, id: value, isCompany } = item;
          return { key, value, isCompany };
        });
        return transformed;
      },
    }
  );
};

const useGetAllObjectiveOKRStateByTenantId = (tenantId: string | null) => {
  return useQuery(
    ["GetAllOKRStateByTenantId", tenantId],
    GetAllOKRStateByTenantId,
    {
      enabled: !!tenantId,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onError: (err) => {
        console.log(err);
      },
      select: (data) => {
        let rawData = data?.data?.data;
        let transformed = rawData
          .map((item: any) => {
            let { id, name } = item;
            return { id, label: name };
          })
          .filter((item: any) => item.label !== "بسته شده");
        return transformed;
      },
    }
  );
};

const useGetObjectiveDetails = (objectiveId: string | null) => {
  return useQuery(["getObjectiveDetails", objectiveId], getObjectiveDetails, {
    enabled: !!objectiveId,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onSuccess: (data: any) => {
      //  console.log(data)
    },
    select: (data) => {
      let rawData = data?.data?.data;
      //  console.log(rawData)
      return rawData;
    },
  });
};

const useGetKeyResultDetailsById = (krId: string | null) => {
  return useQuery(["GetKeyResultDetailsById", krId], getKeyResultDetailsById, {
    enabled: !!krId,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onSuccess: (data: any) => {
      //console.log(data);
    },
    select: (data) => {
      let rawData = data?.data?.data;
      //  console.log(rawData)
      return rawData;
    },
  });
};

const useGetObjectiveDetailsById = (krId: string | null) => {
  return useQuery(["GetObjectiveDetailsById", krId], getObjectiveDetailsById, {
    enabled: !!krId,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    onSuccess: (data: any) => {
      console.log(data);
    },
    select: (data) => {
      let rawData = data?.data?.data;
      //  console.log(rawData)
      return rawData;
    },
  });
};

const useGetAllObjectiveNameWithKeyResultsByTenantId = (Ids: any | null) => {
  return useQuery(
    ["GetAllObjectiveNameWithKeyResultsByTenantId", Ids],
    getAllObjectiveNameWithKeyResultsByTenantId,
    {
      enabled: !!Ids.definitionLevelId,
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      onSuccess: (data: any) => {
        //  console.log(data)
      },
      select: (data) => {
        let rawData = data?.data?.data;
        let transFormed = rawData?.map((item: any) => {
          let { name, keyResultsQueryResultDtos } = item;
          let teransformedd = { gName: name, items: keyResultsQueryResultDtos };
          return teransformedd;
        });
        return transFormed;
      },
    }
  );
};

const useGetAllTeamAndPersonNameByTenantId = (tenantId: any | string) => {
  return useQuery(
    ["GetAllTeamAndPersonNameByTenantId", tenantId],
    getAllTeamAndPersonNameByTenantId,
    {
      enabled: !!tenantId,
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      onSuccess: (data: any) => {
        //  console.log(data)
      },
      select: (data) => {
        let rawData = data?.data?.data;
        return rawData;
      },
    }
  );
};

const useDeleteKr = () => {
  const queryClient = useQueryClient();
  // const dispatch = useDispatch();
  return useMutation({
    mutationFn: (data: any) => {
      return deleteKr(data);
    },
    onSuccess: (data) => {
      console.log(data);
      queryClient.invalidateQueries("getObjectiveDetails");
      queryClient.invalidateQueries("GetObjectiveAndKeyResultCountByPeriodId");
      // queryClient.invalidateQueries("getMyKeyResultByTenantId");
    },
  });
};

const useGetAllVerticalAlignmentByTenantId = 
  (Ids: any | null) => {
  // console.log(periodId)
  return useQuery(
    ["GetAllVerticalAlignmentByTenantId", Ids],
    getAllVerticalAlignmentByTenantId,
    {
      enabled: !!Ids,
      // cacheTime:Infinity,
      refetchOnWindowFocus: false,
      onSuccess: (data: any) => {
        // console.log(data)
      },
      onError: (err) => {
        // console.log(err)
      },
      select: (data) => {
        let rawData = data?.data?.data;
        return rawData;
      },
    }
  );
};

export {
  useGetAllActivePersonByTenantId,
  useGetAllHorizontalAlignmentByTenantId,
  useGetAllOKRStateByTenantId,
  useGetAllScoreLevelsByTenantId,
  useAddKeyResult,
  useGetAllObjectiveByPeriodId,
  useGetAllObjectiveByPeriodId1,
  useGetAllObjectiveByPeriodId2,
  useGetAllObjectiveByPersonId,
  useGetObjectiveAndKeyResultCountByPeriodId,
  useAddObjective,
  useGetAllObjectiveDefinitionLevelByTenantId1,
  useGetAllObjectiveDefinitionLevelByTenantId,
  useGetAllObjectiveOKRStateByTenantId,
  useGetObjectiveDetails,
  useGetAllVerticalAlignmentByTenantId,
  useGetKeyResultDetailsById,
  useEditKeyResult,
  useEditObjective,
  useGetPersonAndTeamCountByTenantId,
  useGetObjectiveDetailsById,
  useDeleteKr,
  useDeleteObject,
  useGetAllObjectiveNameWithKeyResultsByTenantId,
  useGetAllTeamAndPersonNameByTenantId,
  useGetAllActivePersonByTenantIdW,
  useGetFilterByTenantId,
  useGetStrategyMapTenantId,
};
